import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { PalantirTagComponent } from './palantir-tag.component';


@NgModule({
  declarations: [
    PalantirTagComponent
  ],
  imports: [
    CommonModule,
    PipesModule
  ],
  exports: [PalantirTagComponent]
})
export class PalantirTagModule {}
